import type { ColumnDef } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FunctionComponent } from "react"
import { memo } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { Product } from "@/graphql/codegen/graphql"
import { useGetRegulatoryColumns } from "@/screens/Products/components/Product/Regulatory/hooks/useGetRegulatoryColumns"

interface RegulatoryDetailsTableProps {
  productDetails: Pick<Product, "casRegistryIds" | "unNumber" | "isRohsCompliant" | "isReachSvhcCompliant">
}

const RegulatoryDetailsTable: FunctionComponent<RegulatoryDetailsTableProps> = (props: RegulatoryDetailsTableProps) => {
  const { productDetails } = props
  const columns = useGetRegulatoryColumns()

  return (
    <AerosBaseTable
      features={{
        tanstackOptions: {
          data: [productDetails as RegulatoryDetailsTableProps],
          columns: columns as ColumnDef<RegulatoryDetailsTableProps, any>[],
          getCoreRowModel: getCoreRowModel(),
        },
      }}
      slotProps={{
        container: {
          className: "shadow-none",
          component: "div",
        },
        headerCell: {
          className: "h-[22px] w-2/6 border-0 bg-transparent p-0 pb-1",
        },
        bodyCell: {
          className: "h-[12px] border-0 px-0 text-gray-700 py-0",
        },
        bodyRow: {
          className: "border-0",
        },
      }}
    />
  )
}

export default memo(RegulatoryDetailsTable)
